// // frontend/src/components/ProfileDrawer.tsx

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Drawer,
//   Avatar,
//   Typography,
//   Divider,
//   Chip,
//   LinearProgress,
//   IconButton,
//   Button,
//   Skeleton,
//   Alert,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
// } from '@mui/material';
// import {
//   Close as CloseIcon,
//   Person as PersonIcon,
//   Business as BusinessIcon,
//   Email as EmailIcon,
//   Badge as BadgeIcon,
//   Work as WorkIcon,
//   Phone as PhoneIcon,
//   LocationOn as LocationIcon,
//   Upgrade as UpgradeIcon,
//   Lock as LockIcon,
//   Settings as SettingsIcon,
//   Logout as LogoutIcon,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
// import { useTheme as useCustomTheme } from '../context/ThemeContext';
// import api from '../services/api';

// // ─── TYPES ────────────────────────────────────────────────────────────────────

// interface UserProfile {
//   id: string;
//   name: string;
//   email: string;
//   company: string;
//   role: string;
//   job_title?: string;
//   department?: string;
//   phone_number?: string;
//   location?: string;
//   tenant_id?: string;
//   created_at?: string;
//   last_login_at?: string;
// }

// interface UsageStats {
//   vendors: number;
//   users: number;
//   scans: number;
// }

// // ─── PLAN DISPLAY HELPER ─────────────────────────────────────────────────────

// interface PlanDisplay {
//   label: string;
//   badge: string;
//   color: string;
//   bgColor: string;
//   progressColor: string;
//   isExo: boolean;
//   isTropos: boolean;
//   vendorLimit: number | '∞';
//   userLimit: number | '∞';
//   indicatorLimit: number;
// }

// const getPlanDisplay = (plan: string, maxVendors: number, maxUsers: number, maxIndicators: number): PlanDisplay => {
//   if (plan === 'pro') {
//     return {
//       label: 'Exo',
//       badge: '🌌 Exo',
//       color: '#8b5cf6',
//       bgColor: '#8b5cf620',
//       progressColor: '#8b5cf6',
//       isExo: true,
//       isTropos: false,
//       vendorLimit: '∞',
//       userLimit: '∞',
//       indicatorLimit: 226,
//     };
//   }
  
//   if (plan === 'free') {
//     return {
//       label: 'Tropos',
//       badge: '🌤️ Tropos',
//       color: '#6b7280',
//       bgColor: '#6b728020',
//       progressColor: '#3b82f6',
//       isExo: false,
//       isTropos: true,
//       vendorLimit: maxVendors || 5,
//       userLimit: maxUsers || 3,
//       indicatorLimit: maxIndicators || 45,
//     };
//   }
  
//   return {
//     label: 'Tropos',
//     badge: '🌤️ Tropos',
//     color: '#6b7280',
//     bgColor: '#6b728020',
//     progressColor: '#3b82f6',
//     isExo: false,
//     isTropos: true,
//     vendorLimit: maxVendors || 5,
//     userLimit: maxUsers || 3,
//     indicatorLimit: maxIndicators || 45,
//   };
// };

// // ─── HELPER: Format role ─────────────────────────────────────────────────────

// const formatRole = (role?: string): string => {
//   if (!role) return 'User';
//   return role.charAt(0).toUpperCase() + role.slice(1);
// };

// // ─── PROPS ────────────────────────────────────────────────────────────────────

// interface ProfileDrawerProps {
//   open: boolean;
//   onClose: () => void;
//   onOpenChangePassword: () => void;
// }

// // ─── MAIN COMPONENT ──────────────────────────────────────────────────────────

// export default function ProfileDrawer({ open, onClose, onOpenChangePassword }: ProfileDrawerProps) {
//   const navigate = useNavigate();
//   const { user, tenant, logout, refreshTenant } = useAuth();
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   const [profile, setProfile] = useState<UserProfile | null>(null);
//   const [usage, setUsage] = useState<UsageStats>({ vendors: 0, users: 0, scans: 0 });
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   // ─── THEME COLORS ──────────────────────────────────────────────────────────

//   const colors = {
//     text: isDark ? '#e2e8f0' : '#0f172a',
//     muted: isDark ? '#94a3b8' : '#64748b',
//     background: isDark ? '#000000' : '#f8fafc',
//     cardBg: isDark ? '#0d0d0d' : '#ffffff',
//     border: isDark ? '#1f1f1f' : '#e2e8f0',
//     inputBg: isDark ? '#0d0d0d' : '#ffffff',
//     accent: '#2B5C9E',
//     drawerBg: isDark ? '#0d0d0d' : '#ffffff',
//   };

//   // ─── FETCH PROFILE DATA ────────────────────────────────────────────────────

//   const fetchProfileData = async () => {
//     try {
//       setLoading(true);
//       setError(null);

//       // ✅ ONLY call /me - it has ALL data (user + tenant + usage)
//       const meRes = await api.get('/v1/auth/me');
//       const data = meRes.data;

//       console.log('📊 Profile data from /me:', data);

//       // Set user profile
//       setProfile({
//         id: data.id,
//         name: data.name,
//         email: data.email,
//         company: data.company,
//         role: data.role || 'viewer',
//         job_title: data.job_title,
//         department: data.department,
//         phone_number: data.phone_number,
//         location: data.location,
//         tenant_id: data.tenant_id,
//         created_at: data.created_at,
//         last_login_at: data.last_login_at,
//       });

//       // ✅ Use usage from /me (NO /users call)
//       if (data.usage) {
//         setUsage({
//           vendors: data.usage.vendors || 0,
//           users: data.usage.users || 0,
//           scans: data.usage.scans || 0,
//         });
//         console.log('✅ Usage from /me:', data.usage);
//       } else {
//         console.warn('⚠️ No usage data in /me response');
//         setUsage({ vendors: 0, users: 0, scans: 0 });
//       }

//       await refreshTenant();

//     } catch (err: any) {
//       console.error('❌ Failed to fetch profile:', err);
//       setError('Failed to load profile data.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (open) {
//       fetchProfileData();
//     }
//   }, [open]);

//   // ─── HANDLE LOGOUT ─────────────────────────────────────────────────────────

//   const handleLogout = () => {
//     onClose();
//     logout();
//     navigate('/login');
//   };

//   // ─── HANDLE NAVIGATION ─────────────────────────────────────────────────────

//   const handleNavigate = (path: string) => {
//     onClose();
//     navigate(path);
//   };

//   // ─── PLAN DATA ─────────────────────────────────────────────────────────────

//   const plan = tenant?.plan?.plan || 'free';
//   const planStatus = tenant?.plan?.plan_status || 'trial';
//   const maxVendors = tenant?.plan?.max_vendors ?? 5;
//   const maxUsers = tenant?.plan?.max_users ?? 3;
//   const maxIndicators = tenant?.plan?.max_indicators ?? 45;
//   const trialDaysRemaining = tenant?.plan?.trial_days_remaining ?? 0;

//   const planDisplay = getPlanDisplay(plan, maxVendors, maxUsers, maxIndicators);
//   const vendorUsed = usage.vendors || 0;
//   const userUsed = usage.users || 0;
//   const indicatorUsed = Math.min(maxIndicators, 226);

//   const getProgressPercent = (current: number, max: number | '∞'): number => {
//     if (max === '∞' || max === Infinity) return 100;
//     return Math.min((current / max) * 100, 100);
//   };

//   // ─── PROGRESS BAR COMPONENT ───────────────────────────────────────────────

//   const ProgressBar = ({ current, max, color }: { current: number; max: number | '∞'; color: string }) => {
//     const pct = getProgressPercent(current, max);
//     return (
//       <Box sx={{ width: '100%' }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//           <Typography variant="body2" sx={{ color: colors.muted, fontSize: 12 }}>
//             {current} / {max}
//           </Typography>
//           <Typography variant="body2" sx={{ color: colors.muted, fontSize: 12 }}>
//             {max === '∞' ? '100%' : `${Math.round(pct)}%`}
//           </Typography>
//         </Box>
//         <LinearProgress
//           variant="determinate"
//           value={max === '∞' ? 100 : pct}
//           sx={{
//             height: 5,
//             borderRadius: 3,
//             bgcolor: isDark ? '#1f1f1f' : '#e2e8f0',
//             '& .MuiLinearProgress-bar': {
//               bgcolor: max !== '∞' && current >= max ? '#dc2626' : color,
//               borderRadius: 3,
//             },
//           }}
//         />
//       </Box>
//     );
//   };

//   // ─── RENDER ──────────────────────────────────────────────────────────────────

//   return (
//     <Drawer
//       anchor="right"
//       open={open}
//       onClose={onClose}
//       PaperProps={{
//         sx: {
//           width: { xs: '100%', sm: 420 },
//           bgcolor: colors.drawerBg,
//           borderLeft: `1px solid ${colors.border}`,
//           boxShadow: isDark ? '0 0 40px rgba(0,0,0,0.8)' : '0 0 40px rgba(0,0,0,0.1)',
//         },
//       }}
//     >
//       {/* ─── HEADER ──────────────────────────────────────────────────────────── */}
//       <Box sx={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         p: 2,
//         borderBottom: `1px solid ${colors.border}`,
//       }}>
//         <Typography variant="h6" sx={{ fontWeight: 600, color: colors.text }}>
//           Profile
//         </Typography>
//         <IconButton onClick={onClose} sx={{ color: colors.muted }}>
//           <CloseIcon />
//         </IconButton>
//       </Box>

//       {/* ─── CONTENT ────────────────────────────────────────────────────────── */}
//       <Box sx={{ p: 2, overflowY: 'auto', flex: 1 }}>

//         {loading ? (
//           // ─── LOADING STATE ────────────────────────────────────────────────
//           <>
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
//               <Skeleton variant="circular" width={64} height={64} />
//               <Box>
//                 <Skeleton variant="text" width={120} height={28} />
//                 <Skeleton variant="text" width={80} height={20} />
//               </Box>
//             </Box>
//             <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2, mb: 2 }} />
//             <Skeleton variant="rectangular" height={150} sx={{ borderRadius: 2 }} />
//           </>
//         ) : error ? (
//           // ─── ERROR STATE ──────────────────────────────────────────────────
//           <Alert severity="error" sx={{ borderRadius: 2, mt: 2 }}>
//             {error}
//           </Alert>
//         ) : (
//           // ─── PROFILE CONTENT ──────────────────────────────────────────────
//           <>
//             {/* ─── USER INFO ────────────────────────────────────────────────── */}
//             <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
//               <Avatar
//                 sx={{
//                   width: 64,
//                   height: 64,
//                   bgcolor: colors.accent,
//                   fontSize: 26,
//                   fontWeight: 600,
//                   color: '#ffffff',
//                 }}
//               >
//                 {profile?.name?.charAt(0).toUpperCase() || <PersonIcon />}
//               </Avatar>
//               <Box>
//                 <Typography variant="h6" sx={{ fontWeight: 600, color: colors.text }}>
//                   {profile?.name}
//                 </Typography>
//                 <Typography variant="body2" sx={{ color: colors.muted }}>
//                   {formatRole(profile?.role)}
//                 </Typography>
//               </Box>
//             </Box>

//             {/* ─── USER DETAILS ────────────────────────────────────────────── */}
//             <Box sx={{
//               p: 2,
//               borderRadius: 2,
//               bgcolor: isDark ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.02)',
//               border: `1px solid ${colors.border}`,
//               mb: 3,
//             }}>
//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//                 <EmailIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Email
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {profile?.email}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//                 <BusinessIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Company
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {tenant?.company_name || profile?.company}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//                 <WorkIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Job Title
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {profile?.job_title || 'Not set'}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//                 <BadgeIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Department
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {profile?.department || 'Not set'}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
//                 <PhoneIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Phone
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {profile?.phone_number || 'Not set'}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//                 <LocationIcon sx={{ color: colors.muted, fontSize: 18 }} />
//                 <Box>
//                   <Typography variant="caption" sx={{ color: colors.muted, display: 'block', fontSize: 10 }}>
//                     Location
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     {profile?.location || 'Not set'}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>

//             {/* ─── CHIPS ────────────────────────────────────────────────────── */}
//             <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 3 }}>
//               <Chip
//                 label={`Role: ${formatRole(profile?.role)}`}
//                 size="small"
//                 sx={{
//                   bgcolor: isDark ? 'rgba(43, 92, 158, 0.2)' : 'rgba(43, 92, 158, 0.1)',
//                   color: colors.accent,
//                   fontWeight: 500,
//                 }}
//               />
//               {planStatus === 'trial' && (
//                 <Chip
//                   label={`${trialDaysRemaining} days remaining in trial`}
//                   size="small"
//                   sx={{
//                     bgcolor: isDark ? 'rgba(251, 191, 36, 0.2)' : 'rgba(251, 191, 36, 0.1)',
//                     color: '#d97706',
//                     fontWeight: 500,
//                   }}
//                 />
//               )}
//               {planStatus === 'pro' && (
//                 <Chip
//                   label="Active Plan"
//                   size="small"
//                   sx={{
//                     bgcolor: isDark ? 'rgba(34, 197, 94, 0.2)' : 'rgba(34, 197, 94, 0.1)',
//                     color: '#16a34a',
//                     fontWeight: 500,
//                   }}
//                 />
//               )}
//             </Box>

//             {/* ─── PLAN USAGE ────────────────────────────────────────────────── */}
//             <Box sx={{
//               p: 2,
//               borderRadius: 2,
//               border: `1px solid ${colors.border}`,
//               mb: 3,
//             }}>
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600, color: colors.text }}>
//                   Plan Usage
//                 </Typography>
//                 <Chip
//                   label={planDisplay.badge}
//                   size="small"
//                   sx={{
//                     bgcolor: planDisplay.bgColor,
//                     color: planDisplay.color,
//                     fontWeight: 600,
//                     fontSize: 11,
//                   }}
//                 />
//               </Box>

//               <Box sx={{ mb: 2 }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     Vendors
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.muted, fontSize: 12 }}>
//                     {vendorUsed} / {planDisplay.vendorLimit}
//                   </Typography>
//                 </Box>
//                 <ProgressBar 
//                   current={vendorUsed} 
//                   max={planDisplay.vendorLimit} 
//                   color={planDisplay.progressColor} 
//                 />
//               </Box>

//               <Box sx={{ mb: 2 }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     Users
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.muted, fontSize: 12 }}>
//                     {userUsed} / {planDisplay.userLimit}
//                   </Typography>
//                 </Box>
//                 <ProgressBar 
//                   current={userUsed} 
//                   max={planDisplay.userLimit} 
//                   color={planDisplay.progressColor} 
//                 />
//               </Box>

//               <Box>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
//                   <Typography variant="body2" sx={{ color: colors.text, fontWeight: 500, fontSize: 13 }}>
//                     Indicators
//                   </Typography>
//                   <Typography variant="body2" sx={{ color: colors.muted, fontSize: 12 }}>
//                     {indicatorUsed} / 226
//                   </Typography>
//                 </Box>
//                 <ProgressBar
//                   current={indicatorUsed}
//                   max={226}
//                   color={planDisplay.isExo ? planDisplay.progressColor : '#f59e0b'}
//                 />
//               </Box>

//               {!planDisplay.isExo && (
//                 <Button
//                   fullWidth
//                   variant="contained"
//                   startIcon={<UpgradeIcon />}
//                   onClick={() => handleNavigate('/settings')}
//                   sx={{
//                     mt: 2,
//                     bgcolor: colors.accent,
//                     '&:hover': { bgcolor: '#1a4a7a' },
//                     textTransform: 'none',
//                     fontWeight: 600,
//                   }}
//                 >
//                   Upgrade Plan
//                 </Button>
//               )}
//             </Box>

//             {/* ─── ACTIONS ────────────────────────────────────────────────────── */}
//             <Divider sx={{ borderColor: colors.border, mb: 2 }} />

//             <List sx={{ p: 0 }}>
//               <ListItem
//                 component="button"
//                 onClick={() => {
//                   onClose();
//                   onOpenChangePassword();
//                 }}
//                 sx={{
//                   borderRadius: 1,
//                   mb: 0.5,
//                   cursor: 'pointer',
//                   '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
//                 }}
//               >
//                 <ListItemIcon><LockIcon sx={{ color: colors.muted }} /></ListItemIcon>
//                 <ListItemText
//                   primary="Change Password"
//                   primaryTypographyProps={{ fontSize: 14, color: colors.text }}
//                 />
//               </ListItem>

//               <ListItem
//                 component="button"
//                 onClick={() => handleNavigate('/settings')}
//                 sx={{
//                   borderRadius: 1,
//                   mb: 0.5,
//                   cursor: 'pointer',
//                   '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
//                 }}
//               >
//                 <ListItemIcon><SettingsIcon sx={{ color: colors.muted }} /></ListItemIcon>
//                 <ListItemText
//                   primary="Account Settings"
//                   primaryTypographyProps={{ fontSize: 14, color: colors.text }}
//                 />
//               </ListItem>

//               <ListItem
//                 component="button"
//                 onClick={handleLogout}
//                 sx={{
//                   borderRadius: 1,
//                   cursor: 'pointer',
//                   '&:hover': { bgcolor: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)' },
//                 }}
//               >
//                 <ListItemIcon><LogoutIcon sx={{ color: '#dc2626' }} /></ListItemIcon>
//                 <ListItemText
//                   primary="Logout"
//                   primaryTypographyProps={{ fontSize: 14, color: '#dc2626', fontWeight: 500 }}
//                 />
//               </ListItem>
//             </List>
//           </>
//         )}
//       </Box>
//     </Drawer>
//   );
// }

// frontend/src/components/ProfileDrawer.tsx

// frontend/src/components/ProfileDrawer.tsx

import React, { useState, useEffect, useRef } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { Drawer, CircularProgress } from '@mui/material';
import {
  Close as CloseIcon, ArrowBack as ArrowBackIcon, PersonOutline, EditOutlined, BarChartOutlined,
  ShieldOutlined, KeyOutlined, DevicesOutlined, ScheduleOutlined, CheckCircleOutline, InfoOutlined,
  SettingsOutlined, LogoutOutlined, ComputerOutlined, SmartphoneOutlined, LaptopOutlined, DeleteOutline,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme as useCustomTheme } from '../context/ThemeContext';
import { authQueries, settingsQueries } from '../lib/queries';
import api from '../services/api';
import PhoneNumberInput from './PhoneNumberInput';

// ─── TYPES ────────────────────────────────────────────────────────────────────

interface Session {
  id: string;
  session_token: string;
  ip_address: string;
  device: { os: string; browser: string; full: string };
  user_agent: string;
  created_at: string;
  expires_at: string;
  is_current: boolean;
}

interface ProfileDrawerProps {
  open: boolean;
  onClose: () => void;
  onOpenChangePassword: () => void;
  initialView?: 'profile' | 'account';
}

type Hue = 'blue' | 'amber' | 'green' | 'gray' | 'red' | 'purple' | 'coral';
type Palette = ReturnType<typeof palette>;

const sans = "'Inter', system-ui, sans-serif";

const palette = (isDark: boolean) => ({
  isDark,
  ink: isDark ? '#e2e8f0' : '#0f172a',
  slate: isDark ? '#cbd5e1' : '#475569',
  muted: isDark ? '#94a3b8' : '#64748b',
  line: isDark ? '#1f1f1f' : '#e2e8f0',
  surface: isDark ? '#0d0d0d' : '#ffffff',
  surface2: isDark ? '#141414' : '#f8fafc',
  accent: isDark ? '#85B7EB' : '#185FA5',
  danger: isDark ? '#F09595' : '#A32D2D',
});

const HUES: Record<Hue, { light: [string, string]; dark: [string, string] }> = {
  blue: { light: ['#E6F1FB', '#0C447C'], dark: ['#0C2A4A', '#B5D4F4'] },
  amber: { light: ['#FAEEDA', '#633806'], dark: ['#3a2a10', '#FAC775'] },
  green: { light: ['#EAF3DE', '#27500A'], dark: ['#173404', '#C0DD97'] },
  gray: { light: ['#F1EFE8', '#444441'], dark: ['#1f1f1f', '#D3D1C7'] },
  red: { light: ['#FCEBEB', '#A32D2D'], dark: ['#3a1515', '#F09595'] },
  purple: { light: ['#EEEDFE', '#3C3489'], dark: ['#211d4a', '#CECBF6'] },
  coral: { light: ['#FAECE7', '#712B13'], dark: ['#3a1a10', '#F5C4B3'] },
};
const tone = (p: Palette, hue: Hue) => HUES[hue][p.isDark ? 'dark' : 'light'];

// ─── HELPERS ──────────────────────────────────────────────────────────────────

// Plan names only (the old badges carried emoji). Limits come from the tenant record, never from this table.
const planLabel = (plan: string, maxVendors: number): { label: string; hue: Hue } => {
  if (plan === 'pro') return { label: 'Exo', hue: 'purple' };
  if (plan === 'custom') {
    if (maxVendors === 100) return { label: 'Strato', hue: 'blue' };
    if (maxVendors === 500) return { label: 'Meso', hue: 'amber' };
    if (maxVendors === 1000) return { label: 'Thermo', hue: 'coral' };
    return { label: 'Custom', hue: 'blue' };
  }
  return { label: 'Tropos', hue: 'gray' };
};

const ROLE_LABEL: Record<string, string> = {
  super_admin: 'Super admin', admin: 'Admin', risk_analyst: 'Risk analyst', viewer: 'Viewer',
};
const roleLabel = (role?: string) => (role ? ROLE_LABEL[role] || role.charAt(0).toUpperCase() + role.slice(1).replace(/_/g, ' ') : 'User');

const daysSince = (iso?: string | null) => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  return Number.isNaN(t) ? null : Math.floor((Date.now() - t) / 86_400_000);
};

const ago = (iso?: string | null) => {
  const d = daysSince(iso);
  if (d === null) return null;
  if (d <= 0) return 'today';
  if (d === 1) return 'yesterday';
  if (d < 31) return `${d} days ago`;
  const m = Math.floor(d / 30.4);
  if (m < 12) return `${m} month${m === 1 ? '' : 's'} ago`;
  const y = Math.floor(m / 12);
  return `${y} year${y === 1 ? '' : 's'} ago`;
};

const fmtDateTime = (iso?: string | null) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
};

const fmtMonthYear = (iso?: string | null) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};

const deviceIcon = (os = '') => {
  const o = os.toLowerCase();
  if (o.includes('android') || o.includes('ios') || o.includes('iphone') || o.includes('ipad')) return SmartphoneOutlined;
  if (o.includes('mac') || o.includes('linux')) return LaptopOutlined;
  return ComputerOutlined;
};

const TIMEOUT_OPTIONS = [
  { value: 0.25, label: '15 minutes' },
  { value: 0.5, label: '30 minutes' },
  { value: 1, label: '1 hour' },
  { value: 4, label: '4 hours' },
  { value: 8, label: '8 hours' },
  { value: 24, label: '24 hours' },
];
const timeoutLabel = (h?: number) => TIMEOUT_OPTIONS.find(o => o.value === h)?.label || `${h ?? 8} hours`;

const PASSWORD_STALE_DAYS = 90;

// ─── SMALL PIECES ─────────────────────────────────────────────────────────────

const Chip = ({ p, hue, children, strong }: { p: Palette; hue: Hue; children: React.ReactNode; strong?: boolean }) => {
  const [bg, fg] = tone(p, hue);
  return (
    <span style={{ background: bg, color: fg, fontSize: 11.5, fontWeight: strong ? 600 : 500, padding: '2px 9px', borderRadius: 99, whiteSpace: 'nowrap' }}>
      {children}
    </span>
  );
};

const Section = ({ p, icon: Icon, hue, title, right, children }: {
  p: Palette; icon: React.ElementType; hue: Hue; title: string; right?: React.ReactNode; children: React.ReactNode;
}) => {
  const [bg, fg] = tone(p, hue);
  return (
    <section style={{ border: `1px solid ${p.line}`, borderRadius: 10, padding: 14, marginTop: 12, background: p.surface }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 12 }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13.5, fontWeight: 600, color: p.ink }}>
          <span style={{ width: 26, height: 26, borderRadius: 7, background: bg, color: fg, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon sx={{ fontSize: 16 }} />
          </span>
          {title}
        </span>
        {right}
      </div>
      {children}
    </section>
  );
};

const TextBtn = ({ p, onClick, children, color, disabled }: {
  p: Palette; onClick: () => void; children: React.ReactNode; color?: string; disabled?: boolean;
}) => (
  <button onClick={onClick} disabled={disabled} style={{
    background: 'none', border: 'none', padding: 0, cursor: disabled ? 'default' : 'pointer', fontFamily: sans,
    fontSize: 12.5, fontWeight: 600, color: color || p.accent, opacity: disabled ? 0.5 : 1, display: 'inline-flex', alignItems: 'center', gap: 4,
  }}>{children}</button>
);

const Button = ({ p, onClick, children, primary, danger, disabled }: {
  p: Palette; onClick: () => void; children: React.ReactNode; primary?: boolean; danger?: boolean; disabled?: boolean;
}) => (
  <button onClick={onClick} disabled={disabled} style={{
    fontFamily: sans, fontSize: 13, fontWeight: 600, padding: '7px 14px', borderRadius: 8, cursor: disabled ? 'default' : 'pointer',
    border: primary || danger ? 'none' : `1px solid ${p.line}`, opacity: disabled ? 0.6 : 1,
    background: danger ? '#A32D2D' : primary ? '#185FA5' : p.surface, color: primary || danger ? '#fff' : p.ink,
    display: 'inline-flex', alignItems: 'center', gap: 6,
  }}>{children}</button>
);

const Banner = ({ p, kind, children }: { p: Palette; kind: 'ok' | 'error'; children: React.ReactNode }) => {
  const [bg, fg] = tone(p, kind === 'ok' ? 'green' : 'red');
  return <div style={{ background: bg, color: fg, fontSize: 12.5, padding: '8px 12px', borderRadius: 8, marginBottom: 12 }}>{children}</div>;
};

// Vendors / team members: a bar per limit that can actually run out. Amber from 80%, red at the limit.
const Meter = ({ p, label, used, limit }: { p: Palette; label: string; used: number; limit: number | null }) => {
  const pct = limit ? Math.min(100, (used / limit) * 100) : 0;
  const color = !limit ? '#378ADD' : pct >= 100 ? '#E24B4A' : pct >= 80 ? '#EF9F27' : '#378ADD';
  return (
    <div style={{ marginBottom: 11 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, marginBottom: 5 }}>
        <span style={{ color: p.ink }}>{label}</span>
        <span style={{ color: p.muted }}>
          <b style={{ fontWeight: 600, color: p.ink }}>{used}</b> {limit ? `of ${limit}` : '· unlimited'}
        </span>
      </div>
      {limit ? (
        <div style={{ height: 6, background: p.surface2, borderRadius: 99, overflow: 'hidden', border: `1px solid ${p.line}` }}>
          <div style={{ width: `${pct}%`, minWidth: used > 0 ? 6 : 0, height: '100%', background: color, borderRadius: 99 }} />
        </div>
      ) : null}
    </div>
  );
};

const inputStyle = (p: Palette): React.CSSProperties => ({
  width: '100%', boxSizing: 'border-box', fontFamily: sans, fontSize: 13, color: p.ink, background: p.surface,
  border: `1px solid ${p.line}`, borderRadius: 7, padding: '7px 9px', outline: 'none',
});

// ─── MAIN COMPONENT ──────────────────────────────────────────────────────────

const EDITABLE = [
  { key: 'name', label: 'Full name', placeholder: 'Your name' },
  { key: 'job_title', label: 'Job title', placeholder: 'Head of Security' },
  { key: 'department', label: 'Department', placeholder: 'Information Security' },
  { key: 'phone_number', label: 'Phone', placeholder: '+91 98765 43210' },
  { key: 'location', label: 'Location', placeholder: 'Bengaluru, India' },
] as const;
type EditKey = typeof EDITABLE[number]['key'];

export default function ProfileDrawer({ open, onClose, onOpenChangePassword, initialView = 'profile' }: ProfileDrawerProps) {
  const navigate = useNavigate();
  const { user, tenant, logout, refreshTenant } = useAuth();
  const { mode } = useCustomTheme();
  const p = palette(mode === 'dark');
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  const [view, setView] = useState<'profile' | 'account'>(initialView);
  const [notice, setNotice] = useState<{ kind: 'ok' | 'error'; text: string } | null>(null);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState<Record<EditKey, string>>({ name: '', job_title: '', department: '', phone_number: '', location: '' });
  const [formError, setFormError] = useState<string | null>(null);
  const [sessionTimeout, setSessionTimeout] = useState(8);
  const [confirmRevokeAll, setConfirmRevokeAll] = useState(false);

  // ─── SERVER DATA ───────────────────────────────────────────────────────────

  const meQuery = useQuery({ ...authQueries.me(), enabled: open });
  const me = meQuery.data;

  // Usage counts (vendors, team members) come from the same read the Settings > Plan & usage screen uses.
  const settingsQuery = useQuery({ ...settingsQueries.overview(), enabled: open && isAdmin });
  const usage = settingsQuery.data;

  const sessionsQuery = useQuery({
    queryKey: ['auth', 'sessions'],
    queryFn: async () => ((await api.get('/v1/auth/sessions')).data.sessions || []) as Session[],
    enabled: open,
  });
  const sessions = sessionsQuery.data ?? [];
  // You're always signed in on the device you're using, even when no session record exists for it.
  const activeDevices = sessions.some(s => s.is_current) ? sessions.length : sessions.length + 1;

  const flash = (kind: 'ok' | 'error', text: string) => {
    setNotice({ kind, text });
    if (kind === 'ok') setTimeout(() => setNotice(n => (n?.text === text ? null : n)), 3000);
  };
  const errText = (e: any, fallback: string) => {
    const d = e?.response?.data?.detail;
    return typeof d === 'string' ? d : fallback;
  };

  const saveProfile = useMutation({
    mutationFn: (body: Record<string, string>) => api.put('/v1/auth/me', body),
    meta: { invalidates: [['auth'], ['users']] },
  });
  const saveTimeout = useMutation({
    mutationFn: (hours: number) => api.put('/v1/auth/me', { session_timeout_hours: hours }),
    meta: { invalidates: [['auth'], ['users']] },
  });
  const revoke = useMutation({
    mutationFn: (token: string) => api.delete(`/v1/auth/sessions/${token}`),
    meta: { invalidates: [['auth', 'sessions']] },
  });
  const revokeAll = useMutation({
    mutationFn: () => api.post('/v1/auth/sessions/revoke-all'),
    meta: { invalidates: [['auth', 'sessions']] },
  });

  // Reset per opening; the plan limits live in AuthContext, so refresh them too.
  useEffect(() => {
    if (!open) return;
    setView(initialView);
    setNotice(null);
    setEditing(false);
    setConfirmRevokeAll(false);
    refreshTenant();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, initialView]);

  // The timeout select is a form field: seed it once per opening so a background refetch never overwrites it.
  const timeoutSeeded = useRef(false);
  useEffect(() => {
    if (!open) { timeoutSeeded.current = false; return; }
    if (timeoutSeeded.current || !me || meQuery.isFetching) return;
    timeoutSeeded.current = true;
    if (me.session_timeout_hours) setSessionTimeout(me.session_timeout_hours);
  }, [open, me, meQuery.isFetching]);

  const startEdit = () => {
    setForm({
      name: me?.name || '', job_title: me?.job_title || '', department: me?.department || '',
      phone_number: me?.phone_number || '', location: me?.location || '',
    });
    setFormError(null);
    setEditing(true);
  };

  const submitProfile = async () => {
    const trimmed = Object.fromEntries(EDITABLE.map(f => [f.key, form[f.key].trim()])) as Record<EditKey, string>;
    if (!trimmed.name) { setFormError('Enter your name'); return; }
    if (trimmed.phone_number && !/^[+()\d\s.-]{6,20}$/.test(trimmed.phone_number)) { setFormError('Enter a valid phone number'); return; }
    try {
      await saveProfile.mutateAsync(trimmed);
      await refreshTenant(); // also reloads the signed-in user, so the header shows a new name straight away
      setEditing(false);
      flash('ok', 'Profile saved');
    } catch (e) {
      setFormError(errText(e, "Couldn't save your profile. Try again."));
    }
  };

  const go = (path: string) => { onClose(); navigate(path); };
  const handleLogout = () => { onClose(); logout(); navigate('/login'); };

  // ─── PLAN DATA ─────────────────────────────────────────────────────────────

  const plan = tenant?.plan;
  const planName = (() => {
    const derived = planLabel(plan?.plan || 'free', plan?.max_vendors ?? 5);
    // The server's name wins: an override (extra vendors) moves max_vendors off the preset's number.
    const HUE: Record<string, Hue> = { Exo: 'purple', Strato: 'blue', Meso: 'amber', Thermo: 'coral', Tropos: 'gray', Custom: 'blue' };
    return plan?.plan_name ? { label: plan.plan_name, hue: HUE[plan.plan_name] || derived.hue } : derived;
  })();
  const unlimited = plan?.plan === 'pro';
  const allChecks = plan?.all_indicators ?? ((plan?.max_indicators ?? 0) >= 226);
  const checksTotal = plan?.indicators_total;
  const checksIncluded = plan?.indicators_included ?? plan?.max_indicators;
  const statusChip = !plan ? null
    : plan.plan_status === 'trial'
      ? (plan.trial_days_remaining > 0
        ? <Chip p={p} hue="amber">Trial · {plan.trial_days_remaining} day{plan.trial_days_remaining === 1 ? '' : 's'} left</Chip>
        : <Chip p={p} hue="red">Trial ended</Chip>)
      : <Chip p={p} hue="green">Active</Chip>;

  // ─── SECURITY DATA ─────────────────────────────────────────────────────────

  const pwDays = daysSince(me?.password_changed_at);
  const pwChip = pwDays === null
    ? <Chip p={p} hue="gray">Not recorded</Chip>
    : <Chip p={p} hue={pwDays > PASSWORD_STALE_DAYS ? 'amber' : 'green'}>Changed {ago(me?.password_changed_at)}</Chip>;

  // ─── VIEWS ─────────────────────────────────────────────────────────────────

  const field = (label: string, value?: string | null, onAdd?: () => void) => (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 11.5, color: p.muted }}>{label}</div>
      {value
        ? <div style={{ fontSize: 13, fontWeight: 500, color: p.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={value}>{value}</div>
        : <TextBtn p={p} onClick={onAdd || (() => {})}>+ Add</TextBtn>}
    </div>
  );

  const securityRow = (icon: React.ElementType, label: string, right: React.ReactNode, last?: boolean) => {
    const Icon = icon;
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, padding: '9px 0', borderBottom: last ? 'none' : `1px solid ${p.line}` }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 13, color: p.ink }}>
          <Icon sx={{ fontSize: 16, color: p.muted }} />{label}
        </span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>{right}</span>
      </div>
    );
  };

  const renderProfile = () => (
    <>
      {/* identity */}
      <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
        <div style={{ width: 56, height: 56, borderRadius: '50%', background: '#185FA5', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22, fontWeight: 600, flexShrink: 0 }}>
          {(me?.name || '?').charAt(0).toUpperCase()}
        </div>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div style={{ fontSize: 16, fontWeight: 600, color: p.ink, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{me?.name}</div>
          <div style={{ fontSize: 12.5, color: p.muted, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{me?.email}</div>
          <div style={{ display: 'flex', gap: 6, marginTop: 7, flexWrap: 'wrap' }}>
            <Chip p={p} hue="blue" strong>{roleLabel(me?.role)}</Chip>
            {(tenant?.company_name || me?.company) && <Chip p={p} hue="gray">{tenant?.company_name || me?.company}</Chip>}
          </div>
        </div>
      </div>

      {/* about you */}
      <Section p={p} icon={PersonOutline} hue="blue" title="About you"
        right={!editing && <TextBtn p={p} onClick={startEdit}><EditOutlined sx={{ fontSize: 14 }} /> Edit</TextBtn>}>
        {editing ? (
          <div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px 12px' }}>
              {EDITABLE.map(f => (
                <label key={f.key} style={{ gridColumn: f.key === 'name' ? '1 / -1' : undefined, display: 'block' }}>
                  <span style={{ display: 'block', fontSize: 11.5, color: p.muted, marginBottom: 4 }}>{f.label}</span>
                  {f.key === 'phone_number' ? (
                    <PhoneNumberInput value={form[f.key]} placeholder="98765 43210" inputStyle={inputStyle(p)}
                      onChange={v => { setForm(prev => ({ ...prev, [f.key]: v })); setFormError(null); }} />
                  ) : (
                    <input value={form[f.key]} placeholder={f.placeholder} maxLength={100}
                      onChange={e => { setForm(prev => ({ ...prev, [f.key]: e.target.value })); setFormError(null); }}
                      style={inputStyle(p)} />
                  )}
                </label>
              ))}
            </div>
            {formError && <div style={{ fontSize: 12.5, color: p.danger, marginTop: 8 }}>{formError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12 }}>
              <Button p={p} onClick={() => setEditing(false)} disabled={saveProfile.isPending}>Cancel</Button>
              <Button p={p} primary onClick={submitProfile} disabled={saveProfile.isPending}>
                {saveProfile.isPending && <CircularProgress size={13} sx={{ color: '#fff' }} />}Save
              </Button>
            </div>
          </div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 14px' }}>
            {field('Job title', me?.job_title, startEdit)}
            {field('Phone', me?.phone_number, startEdit)}
            {field('Department', me?.department, startEdit)}
            {field('Location', me?.location, startEdit)}
          </div>
        )}
      </Section>

      {/* plan usage: admins only, the same as the Settings screen it links to */}
      {isAdmin && plan && (
        <Section p={p} icon={BarChartOutlined} hue="amber" title="Plan usage"
          right={<span style={{ display: 'flex', gap: 6 }}><Chip p={p} hue={planName.hue} strong>{planName.label}</Chip>{statusChip}</span>}>
          {usage ? (
            <>
              <Meter p={p} label="Vendors" used={usage.vendor_count} limit={unlimited ? null : plan.max_vendors} />
              <Meter p={p} label="Team members" used={usage.team.total} limit={unlimited ? null : plan.max_users} />
            </>
          ) : <div style={{ height: 70, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><CircularProgress size={18} /></div>}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, padding: '9px 10px', background: p.surface2, borderRadius: 8, fontSize: 12.5, color: p.slate, lineHeight: 1.45 }}>
            {allChecks ? (
              <><CheckCircleOutline sx={{ fontSize: 17, color: p.isDark ? '#97C459' : '#3B6D11', mt: '1px' }} />
                <span>All <b style={{ color: p.ink }}>{checksTotal ?? ''}</b> security checks run on every scan</span></>
            ) : (
              <><InfoOutlined sx={{ fontSize: 17, color: p.isDark ? '#FAC775' : '#854F0B', mt: '1px' }} />
                <span><b style={{ color: p.ink }}>{checksIncluded}</b>{checksTotal ? ` of ${checksTotal}` : ''} security checks run on your plan. Upgrade to run every check.</span></>
            )}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12 }}>
            <span style={{ fontSize: 11.5, color: p.muted }}>{unlimited ? 'No limits on your plan' : 'Bars turn amber at 80%, red at the limit'}</span>
            <TextBtn p={p} onClick={() => go('/settings?section=plan')}>{allChecks ? 'Manage plan' : 'Upgrade plan'} →</TextBtn>
          </div>
        </Section>
      )}

      {/* sign-in and security */}
      <Section p={p} icon={ShieldOutlined} hue="green" title="Sign-in and security">
        {securityRow(KeyOutlined, 'Password', <>{pwChip}<TextBtn p={p} onClick={() => { onClose(); onOpenChangePassword(); }}>Change</TextBtn></>)}
        {securityRow(DevicesOutlined, 'Signed-in devices', <>
          <Chip p={p} hue="blue">{sessionsQuery.isPending ? '…' : `${activeDevices} active`}</Chip>
          <TextBtn p={p} onClick={() => setView('account')}>Manage</TextBtn>
        </>)}
        {securityRow(ScheduleOutlined, 'Auto sign-out', <>
          <span style={{ fontSize: 12.5, color: p.muted }}>After {timeoutLabel(me?.session_timeout_hours)}</span>
          <TextBtn p={p} onClick={() => setView('account')}>Change</TextBtn>
        </>, true)}
      </Section>

      {(me?.created_at || me?.last_login_at) && (
        <div style={{ fontSize: 12, color: p.muted, textAlign: 'center', marginTop: 14 }}>
          {[me?.created_at && `Member since ${fmtMonthYear(me.created_at)}`, me?.last_login_at && `Last sign-in ${fmtDateTime(me.last_login_at)}`].filter(Boolean).join(' · ')}
        </div>
      )}
    </>
  );

  const renderAccount = () => (
    <>
      <Section p={p} icon={ScheduleOutlined} hue="blue" title="Auto sign-out">
        <div style={{ fontSize: 12.5, color: p.muted, marginBottom: 8 }}>Sign out automatically after this long. Applies from your next sign-in.</div>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={sessionTimeout} onChange={e => setSessionTimeout(Number(e.target.value))} style={{ ...inputStyle(p), flex: 1 }}>
            {TIMEOUT_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
          <Button p={p} primary disabled={saveTimeout.isPending || sessionTimeout === (me?.session_timeout_hours || 8)}
            onClick={async () => {
              try { await saveTimeout.mutateAsync(sessionTimeout); await refreshTenant(); flash('ok', 'Auto sign-out updated'); }
              catch (e) { flash('error', errText(e, "Couldn't update auto sign-out.")); }
            }}>
            {saveTimeout.isPending && <CircularProgress size={13} sx={{ color: '#fff' }} />}Save
          </Button>
        </div>
      </Section>

      <Section p={p} icon={DevicesOutlined} hue="green" title="Signed-in devices"
        right={<Chip p={p} hue="blue">{activeDevices} active</Chip>}>
        {sessionsQuery.isPending ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 12 }}><CircularProgress size={20} /></div>
        ) : (<>
        {!sessions.some(s => s.is_current) && (
          // No session record for this device: still list it, since it is signed in right now.
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0' }}>
            <span style={{ width: 30, height: 30, borderRadius: 8, background: p.surface2, color: p.muted, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <ComputerOutlined sx={{ fontSize: 17 }} />
            </span>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 500, color: p.ink }}>
                This browser <Chip p={p} hue="green">This device</Chip>
              </div>
              <div style={{ fontSize: 11.5, color: p.muted }}>Signed in now</div>
            </div>
          </div>
        )}
        {sessions.map((s, i) => {
          const Icon = deviceIcon(s.device?.os);
          return (
            <div key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 0', borderTop: i || !sessions.some(x => x.is_current) ? `1px solid ${p.line}` : 'none' }}>
              <span style={{ width: 30, height: 30, borderRadius: 8, background: p.surface2, color: p.muted, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icon sx={{ fontSize: 17 }} />
              </span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 500, color: p.ink }}>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{s.device?.browser || 'Unknown browser'} on {s.device?.os || 'unknown device'}</span>
                  {s.is_current && <Chip p={p} hue="green">This device</Chip>}
                </div>
                <div style={{ fontSize: 11.5, color: p.muted }}>{s.ip_address || 'Unknown IP'} · signed in {fmtDateTime(s.created_at)}</div>
              </div>
              {!s.is_current && (
                <button title="Sign out this device" disabled={revoke.isPending && revoke.variables === s.session_token}
                  onClick={async () => {
                    try { await revoke.mutateAsync(s.session_token); flash('ok', 'Device signed out'); }
                    catch (e) { flash('error', errText(e, "Couldn't sign out that device.")); }
                  }}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: p.muted, padding: 4, display: 'inline-flex' }}>
                  {revoke.isPending && revoke.variables === s.session_token ? <CircularProgress size={15} /> : <DeleteOutline sx={{ fontSize: 18 }} />}
                </button>
              )}
            </div>
          );
        })}
        </>)}
        {activeDevices > 1 && (confirmRevokeAll ? (
          <div style={{ marginTop: 10, padding: 12, borderRadius: 8, background: tone(p, 'red')[0] }}>
            <div style={{ fontSize: 12.5, color: tone(p, 'red')[1], marginBottom: 10 }}>
              Every other device will be signed out and will need to sign in again.
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <Button p={p} onClick={() => setConfirmRevokeAll(false)}>Cancel</Button>
              <Button p={p} danger disabled={revokeAll.isPending} onClick={async () => {
                try { await revokeAll.mutateAsync(); setConfirmRevokeAll(false); flash('ok', 'Other devices signed out'); }
                catch (e) { flash('error', errText(e, "Couldn't sign out the other devices.")); }
              }}>{revokeAll.isPending && <CircularProgress size={13} sx={{ color: '#fff' }} />}Sign out others</Button>
            </div>
          </div>
        ) : (
          <div style={{ marginTop: 8 }}>
            <TextBtn p={p} color={p.danger} onClick={() => setConfirmRevokeAll(true)}>Sign out all other devices</TextBtn>
          </div>
        ))}
      </Section>
    </>
  );

  // ─── RENDER ──────────────────────────────────────────────────────────────────

  return (
    // Above the fixed app header (which sits over MUI's default modal layer), so the title isn't hidden.
    <Drawer anchor="right" open={open} onClose={onClose} sx={{ zIndex: 1600 }} PaperProps={{
      sx: {
        width: { xs: '100%', sm: 420 }, bgcolor: p.surface, borderLeft: `1px solid ${p.line}`, boxShadow: 'none',
        display: 'flex', flexDirection: 'column', fontFamily: sans,
      },
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '14px 18px', borderBottom: `1px solid ${p.line}`, flexShrink: 0 }}>
        {view === 'account' && (
          <button onClick={() => setView('profile')} aria-label="Back" style={{ background: 'none', border: 'none', cursor: 'pointer', color: p.muted, padding: 2, display: 'inline-flex' }}>
            <ArrowBackIcon sx={{ fontSize: 19 }} />
          </button>
        )}
        <span style={{ flex: 1, fontSize: 15, fontWeight: 600, color: p.ink }}>{view === 'profile' ? 'Your account' : 'Devices and sign-out'}</span>
        <button onClick={onClose} aria-label="Close" style={{ background: 'none', border: 'none', cursor: 'pointer', color: p.muted, padding: 2, display: 'inline-flex' }}>
          <CloseIcon sx={{ fontSize: 19 }} />
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: 18 }}>
        {notice && <Banner p={p} kind={notice.kind}>{notice.text}</Banner>}
        {meQuery.isPending ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: 40 }}><CircularProgress size={24} /></div>
        ) : meQuery.isError ? (
          <Banner p={p} kind="error">Couldn't load your profile. Close this panel and try again.</Banner>
        ) : view === 'profile' ? renderProfile() : renderAccount()}
      </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 18px', borderTop: `1px solid ${p.line}`, flexShrink: 0 }}>
        <TextBtn p={p} color={p.slate} onClick={() => go('/settings')}><SettingsOutlined sx={{ fontSize: 16 }} /> Workspace settings</TextBtn>
        <TextBtn p={p} color={p.danger} onClick={handleLogout}><LogoutOutlined sx={{ fontSize: 16 }} /> Sign out</TextBtn>
      </div>
    </Drawer>
  );
}
